import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ServiceGroupRecord, DataService } from '@core/services/data.service';
import { ModalService } from '@common/services/modal.service';

@Component({
  templateUrl: './group-editor.component.html',
  styleUrls: ['./group-editor.component.scss']
})
export class GroupEditorComponent implements OnInit {

  @Input()
  public group: ServiceGroupRecord;

  @Output()
  public change = new EventEmitter<ServiceGroupRecord>();

  constructor(private modal: ModalService, private ds: DataService) { }

  ngOnInit(): void {

    this.group = this.group ? { ... this.group } : { ID: 0, Name: '', Description: '' };
  }

  public close() {
    this.modal.of(this).hide();
  }

  public save() {
    this.ds.groups(this.group.ID > 0 ? 'update' : 'create', this.group).subscribe(groups => {
      if (groups && groups.length == 1) {
        this.group = groups[0];
        this.change.emit(this.group);
        this.modal.of(this).hide();
      }
    });
  }
}
